import VimeoPlayer from '@vimeo/player';
import React, {Component} from 'react';
import './PlayerIFrame.css';

function videoIdToUrl(videoId: string|number, mode?: string): string {
    switch (mode) {
        case 'background':
            return 'https://player.vimeo.com/video/' + videoId + '?background=1';
        case 'autoplay':
            return 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
        case 'normal': // If "normal" or unknown mode, use "normal";
        default:
            return 'https://player.vimeo.com/video/' + videoId;
    }
}

interface PlayerIframeProps {
    videoId: string|number;
    mode?: 'background'|'autoplay'|'normal'|string;
    /**
     * If passed, a Vimeo Player will be created and passed to this callback.
     *
     * If the iframe ever gets replaced with a new one, this will be called
     * again with a new Vimeo Player each time.
     */
    onCreateVimeoPlayer?: (vimeoPlayer: VimeoPlayer, error?: Error) => void;
    /**
     * Amount of time to wait before failing to load
     */
    loadedTimeoutMs?: number;
}

export default class PlayerIFrame extends Component<PlayerIframeProps> {

    public static defaultProps: Partial<PlayerIframeProps> = {
        loadedTimeoutMs: 10000,
    };
    private iframe: HTMLIFrameElement = null;
    private loadTimeoutId: any;

    public ref = (iframe: HTMLIFrameElement) => this.iframe = iframe;

    public componentDidMount() {
        if (!this.props.onCreateVimeoPlayer) {
            return;
        }
        try {
            const player = new (VimeoPlayer as any)(this.iframe);
            player.on('loaded', () => {
                clearTimeout(this.loadTimeoutId);
                this.props.onCreateVimeoPlayer(player, null);
            });
            player.on('error', (error) => {
                clearTimeout(this.loadTimeoutId);
                this.props.onCreateVimeoPlayer(player, error);
            });
            if (this.loadTimeoutId) {
                clearTimeout(this.loadTimeoutId);
            }
            this.loadTimeoutId = window.setTimeout(() => {
                this.props.onCreateVimeoPlayer(
                    player,
                    new Error('Load timed out')
                );
            }, this.props.loadedTimeoutMs);
        } catch (error) {
            this.props.onCreateVimeoPlayer(null, error);
        }
    }

    public componentWillUnmount() {
        if (this.loadTimeoutId) {
            clearTimeout(this.loadTimeoutId);
        }
    }

    public render() {
        return <iframe className="PlayerIFrame"
                       ref={this.ref}
                       src={videoIdToUrl(this.props.videoId, this.props.mode)}
                       frameBorder="0"
                       allowFullScreen={true}
        />;
    }
}
